import { jsxs as i, jsx as a } from "react/jsx-runtime";
import e from "classnames";
import { ROW_HEIGHTS as z } from "./index.es531.js";
import o from "./index.es5639.js";
import { ColorIndicator as B } from "./index.es26.js";
import { Thumbnail as I } from "./index.es119.js";
import { Bullets as E } from "./index.es497.js";
import { Badge as S } from "./index.es5.js";
import { BodyText as h } from "./index.es487.js";
const b = ({
  badge: c,
  entityAddress: s,
  entityName: n,
  thumbnailProps: d,
  gridDensity: r = "standard",
  entityColor: f,
  bullets: l,
  testId: t,
  isCustomEntity: p
}) => {
  const m = r === "comfort", v = {
    "--cellSize": `${z[r]}px`
  }, C = e(o.contentContainer, [o[r]]), N = e(o.colorIndicator, [
    o[r],
    { [o.hasBullets]: !!(l != null && l.length) }
  ]), x = e(o.root, [o[r]]), u = e(o.info, {
    [o.comfort]: m
  });
  return /* @__PURE__ */ i("div", { "data-testid": t, className: x, style: v, children: [
    /* @__PURE__ */ i("div", { className: C, children: [
      (f || p) && /* @__PURE__ */ a("div", { className: N, children: /* @__PURE__ */ a(
        B,
        {
          entityColor: f,
          color: p ? "var(--plac-additionals-custompoi)" : void 0,
          testId: t + "-color-indicator"
        }
      ) }),
      d && /* @__PURE__ */ a(
        I,
        {
          size: m ? "medium" : "small",
          ...d,
          testId: t + "-thumbnail"
        }
      ),
      /* @__PURE__ */ i("div", { className: u, children: [
        /* @__PURE__ */ i(
          h,
          {
            variant: m ? "bold" : "semi-bold",
            size: "default",
            isEllipsis: !0,
            element: "label",
            children: [
              n,
              " ",
              !m && s && n ? "|" : ""
            ]
          }
        ),
        /* @__PURE__ */ a(h, { variant: "regular", size: "small", isEllipsis: !0, element: "p", children: s }),
        r === "comfort" && /* @__PURE__ */ a(E, { bullets: l })
      ] })
    ] }),
    c && /* @__PURE__ */ a(S, { label: c, testId: t + "-badge" })
  ] });
};
export {
  b as EntityCell
};
//# sourceMappingURL=index.es634.js.map
